module.exports = __webpack_public_path__ + "e5d7fd1b2ee438320338f0866cfef135.svg";